import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M13.8283 1.5H2.16767C1.52385 1.5 1 2.02385 1 2.66767V14.3323C1 14.9762 1.52385 15.5 2.16767 15.5H13.8323C14.4762 15.5 15 14.9762 15 14.3323V2.66767C15 2.02385 14.4762 1.5 13.8323 1.5H13.8283Z",
      stroke: "#949494",
      "stroke-width": "1.3"
    }, null, -1),
    _createElementVNode("path", {
      d: "M1 5.7749H14.996M5.27478 15.4961V5.7749",
      stroke: "#949494",
      "stroke-width": "1.3"
    }, null, -1)
  ])))
}
export default { render: render }